import { render, staticRenderFns } from "./addEmployee.vue?vue&type=template&id=70356db0&scoped=true"
import script from "./addEmployee.vue?vue&type=script&lang=js"
export * from "./addEmployee.vue?vue&type=script&lang=js"
import style0 from "./addEmployee.vue?vue&type=style&index=0&id=70356db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70356db0",
  null
  
)

export default component.exports